import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getInventoryAuditLogSearchOption = get(
  'inventory.auditLogSearchOption'
);

export const getUserSearchOptions = createSelector(
  getInventoryAuditLogSearchOption,
  get('users')
);

export const getItemSearchOptions = createSelector(
  getInventoryAuditLogSearchOption,
  get('items')
);

export const getLocationSearchOptions = createSelector(
  getInventoryAuditLogSearchOption,
  get('locations')
);

export const getZoneSearchOptions = createSelector(
  getInventoryAuditLogSearchOption,
  get('zones')
);

export const getTagSearchOptions = createSelector(
  getInventoryAuditLogSearchOption,
  get('tags')
);

export const getIsFetching = createSelector(
  getInventoryAuditLogSearchOption,
  get('fetching')
);
export const getIsFetched = createSelector(
  getInventoryAuditLogSearchOption,
  get('fetched')
);
export const getFetchingError = createSelector(
  getInventoryAuditLogSearchOption,
  get('fetchingError')
);
